import BaseModel from '@/models/BaseModel';

export default class LabServiceModel extends BaseModel {
  routes() {
    return {
      fetch: `${process.env.VUE_APP_LAB_REPOSITORY_URL}/api/v1/${this.modelName()}/{id}`,
      save: `${process.env.VUE_APP_LAB_REPOSITORY_URL}/api/v1/${this.modelName()}`,
      update: `${process.env.VUE_APP_LAB_REPOSITORY_URL}/api/v1/${this.modelName()}/{id}`,
      create: `${process.env.VUE_APP_LAB_REPOSITORY_URL}/api/v1/${this.modelName()}`,
      delete: `${process.env.VUE_APP_LAB_REPOSITORY_URL}/api/v1/${this.modelName()}/{id}`,
      fetchConnection: `${process.env.VUE_APP_LAB_REPOSITORY_URL}/api/v1/${this.modelName()}/{id}/connection/{connection}`,
    }
  }

  getRoute(key) {
    let routes = this.routes();
    return routes[key];
  }

}
